import useFixedLoop from '../fixedLoop.js';

export default function (length) {
    return {
        current: 0,
        accumulatedTimeMs: 0,
        timePerSlide: 2000,

        init(ms) {
            this.timePerSlide = ms;
            this.update = this.update.bind(this);
            const { start } = useFixedLoop(40, this.update)
            start();
        },
        update(dt) {
            this.accumulatedTimeMs += (dt * 1000);

            const item = this.getElement();
            const percentage = this.calcPercentage();

            item.style.width = `${percentage}%`;
            if (this.accumulatedTimeMs >= this.timePerSlide) {
                this.accumulatedTimeMs = 0;
                if (this.current >= length- 1) {
                    this.current = 0
                    this.resetAllProgress();
                } else {
                    this.current += 1;
                }
            }
        },
        getElement(i = this.current) {
            return this.$refs['projector' + i];
        },
        calcPercentage() {
            return Math.min(100, Math.ceil((this.accumulatedTimeMs / this.timePerSlide) * 100));
        },
        resetAllProgress() {
            for (let i = 0; i < length; i++) {
                const el = this.getElement(i);
                el.style.width = `0%`;           
            }
        }

    }
}